module.exports = __webpack_public_path__ + "media/images/undraw/matching/business_deal-978f4d6dd1acb420c4aac7b9e021331c.png";